__turbopack_context__.v({
  "actionButton": "Snackbar-module__RDnzLW__actionButton",
  "body": "Snackbar-module__RDnzLW__body",
  "closeButton": "Snackbar-module__RDnzLW__closeButton",
  "description": "Snackbar-module__RDnzLW__description",
  "icon": "Snackbar-module__RDnzLW__icon",
  "large": "Snackbar-module__RDnzLW__large",
  "messageMultiline": "Snackbar-module__RDnzLW__messageMultiline",
  "middle": "Snackbar-module__RDnzLW__middle",
  "root": "Snackbar-module__RDnzLW__root",
  "small": "Snackbar-module__RDnzLW__small",
  "withButton": "Snackbar-module__RDnzLW__withButton",
  "withButtonContent": "Snackbar-module__RDnzLW__withButtonContent",
});
